import { ActionReducer, MetaReducer, Action } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { AppState } from './app.reducer';
import * as ErrorActions from './error/actions/error.actions';
import { HttpErrorResponse } from '@angular/common/http';

// SECURITY: the 'auth' slice is intentionally NOT persisted. The refresh token lives in an
// HttpOnly cookie (unreadable by JS) and the access token is held in memory only, so an XSS
// foothold cannot exfiltrate either from storage. The access token is re-minted on app start
// via a silent cookie refresh (see provideAppInitializer in app.config.ts).
const localStorageSyncReducer = (reducer: ActionReducer<AppState>): ActionReducer<AppState> =>
  localStorageSync({ keys: ['user', 'gdpr'], rehydrate: true })(reducer);

const errorHandlingReducer = (reducer: ActionReducer<AppState>): ActionReducer<AppState> => {
  return (state, action) => {
    // First run the action through the normal reducer
    const nextState = reducer(state, action);

    // Handle any action that ends with 'Failure'
    if (action.type.endsWith('Failure')) {
      console.error('Global error detected:', action);

      // Check if the action has error information
      const actionWithError = action as Action & {
        error?: HttpErrorResponse | never;
      };

      if (actionWithError.error) {
        // Create and dispatch error action
        const errorAction = actionWithError.error.status
          ? ErrorActions.HttpError({
              httpError: actionWithError.error as HttpErrorResponse,
              actionType: action.type,
            })
          : ErrorActions.GlobalError({
              error: {
                statusCode: 500,
                message: actionWithError.error.message || 'An error occurred',
                timestamp: new Date(),
                actionType: action.type,
                details: actionWithError.error,
              },
            });

        // Apply the error action to the state
        return reducer(nextState, errorAction);
      }
    }

    return nextState;
  };
};

export const metaReducers: Array<MetaReducer<AppState>> = [
  localStorageSyncReducer,
  errorHandlingReducer,
];
